module.exports = new __parcel__URL__("delivery-light.64ac0f3e.svg").toString();